import { Form, Formik } from 'formik';
import React from 'react';
import CustomPasswordField from '../../components/CustomPasswordField/CustomPasswordField';
import { Stack, Typography } from '@mui/material';
import { axiosInstance } from '../../../axiosApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CustomToastMessage from '../../components/CustomToastMessage/CustomeToastMessage';

import * as Yup from 'yup';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import PageWrapperLayout from '../PageWrapperLayout/PageWrapperLayout';
import MDBox from '../../ui-kit/components/MDBox';
import { Card, CardContent } from '@mui/material';
import MDTypography from '../../ui-kit/components/MDTypography';
import MDButton from '../../ui-kit/components/MDButton';
import ParticleBackground from '../../components/ParticleBackground/ParticleBackground';


export type PasswordResetValues = {
    password1: string;
    password2: string;
};

const initialValues = { password1: '', password2: '' }
const validationSchema = Yup.object().shape({
    password1: Yup.string().min(6, "Passwords have to be at least 6 digits").required(),
    password2: Yup.string().min(6, "Passwords have to be at least 6 digits").required().oneOf([Yup.ref('password1')], "Passwords must match"),
})

const contains_number = (item: string): boolean => {
    const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    const hasNumber = numbers.some((character) => item.includes(character));
    if (hasNumber) {
        return true;
    }
    return false;
}

const contains_special_character = (item: string): boolean => {
    const specialCharacters = ['!', '@', '#', '$', ',%', '^', '&', '*', '(', ')', '-', '_', '=', '+', '/', '*', '\\', '|', '`', '~', '<', '>', '.', '?'];
    const hasSpecialChacater = specialCharacters.some((character) => item.includes(character));
    if (hasSpecialChacater) {
        return true;
    }
    return false;
}

const SetPassword = (): JSX.Element => {
    const navigate = useNavigate();
    // see if the user is allowed to come here first
    const [queryParameters] = useSearchParams()
    console.log(queryParameters.get("slug"))
    const slug = queryParameters.get("slug");


    try {
        // make sure it comes back as 200 for a good request. Else go to the homepage
        axiosInstance.get(`user/set_password/${slug}`)
    } catch {
        navigate('/')
    }

    const handleSetPassword = ({ password1, password2 }: PasswordResetValues): void => {
        try {
            // verify 
            if (password1 === password2) {
                axiosInstance.post(`user/set_password/${slug}/`, {
                    'password': password1,
                });

                navigate('/')
            }
        } catch (error) {
            console.log('catching the error');
            <CustomToastMessage message={error as string} />

        }
    }

    return (

        <PageWrapperLayout>
            <MDBox sx={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                bgcolor: 'background.default',
                position: 'relative'
            }}>
                <ParticleBackground />
                <MDBox sx={{ width: '100%', maxWidth: '400px', zIndex: 1, position: 'relative' }}>
                    <Card>
                        <CardContent>
                            <MDTypography variant="h4" textAlign="center">
                                Set your password
                            </MDTypography>
                        </CardContent>
                        <div className='card-body text-center'>
                            <Formik
                                initialValues={initialValues}
                                onSubmit={handleSetPassword}
                                validateOnMount
                                validationSchema={validationSchema}>
                                {(formik) => (
                                    <Form>
                                        <div className='row'>
                                            <div className='col'>
                                                <CustomPasswordField
                                                    label='Password'
                                                    name="password1"
                                                    changeHandler={(e) => formik.setFieldValue('password1', e.target.value)} />

                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col'>
                                                <CustomPasswordField
                                                    label='Confirm Password'
                                                    name="password2"
                                                    changeHandler={(e) => formik.setFieldValue('password2', e.target.value)} />

                                            </div>
                                        </div>
                                        <div>
                                            <Stack alignItems="center" direction="row" gap={2}>
                                                {formik.values.password1 === formik.values.password2 ? <CheckCircleIcon fontSize='small' color='success' /> : <ErrorIcon fontSize='small' color='warning' />}

                                                <Typography variant="body1">Passwords Match</Typography>
                                            </Stack>
                                        </div>
                                        <div>
                                            <Stack alignItems="center" direction="row" gap={2}>
                                                {formik.values.password1.length > 5 ? <CheckCircleIcon fontSize='small' color='success' /> : <ErrorIcon fontSize='small' color='warning' />}
                                                <Typography variant="body1">At least 6 characters</Typography>
                                            </Stack>
                                        </div>
                                        <div>
                                            <Stack alignItems="center" direction="row" gap={2}>
                                                {contains_special_character(formik.values.password1) ? <CheckCircleIcon fontSize='small' color='success' /> : <ErrorIcon fontSize='small' color='warning' />}
                                                <Typography variant="body1">At least one special character</Typography>
                                            </Stack>
                                        </div>
                                        <div>
                                            <Stack alignItems="center" direction="row" gap={2}>

                                                {contains_number(formik.values.password1) ? <CheckCircleIcon fontSize='small' color='success' /> : <ErrorIcon fontSize='small' color='warning' />}
                                                <Typography variant="body1">At least one number</Typography>
                                            </Stack>
                                        </div>
                                        <div className='row'>
                                            <div className='col'>
                                                <MDButton
                                                    type={'submit'}
                                                    fullWidth
                                                    disabled={!formik.isValid || formik.isSubmitting ||
                                                        !contains_special_character(formik.values.password1)
                                                        || !contains_number(formik.values.password1)
                                                    }

                                                //   type={'submit'}
                                                //   loading={formik.isSubmitting}
                                                //   disabled={
                                                //     !formik.isValid || !formik.dirty || formik.isSubmitting
                                                // }
                                                >
                                                    Set password
                                                </MDButton>


                                            </div>
                                        </div>

                                    </Form>
                                )}

                            </Formik>
                        </div>
                    </Card>
                </MDBox>
            </MDBox>
        </PageWrapperLayout>
    );
};

export default SetPassword;